import { Card, CardContent, Stack, Typography } from '@mui/material';
import { PropsWithChildren } from 'react';

interface IScreenCardContentProps extends PropsWithChildren {
  title?: string;
}

export const ScreenCardContent = ({
  title,
  children,
}: IScreenCardContentProps): JSX.Element => {
  return (
    <Card
      sx={{
        mt: {
          xs: 3,
          sm: 0,
        },
        p: 1,
        borderRadius: 2.5,
        backgroundColor: 'rgba(27, 28, 29, 0.6)',
        border: '1px solid',
        borderColor: theme => theme.palette.grey['50'],
      }}
    >
      <CardContent
        sx={{
          minWidth: 300,
          borderRadius: 2.5,

          backgroundColor: 'rgba(27, 28, 29, 0.6)',
        }}
      >
        {title && (
          <Stack
            mb={3}
            sx={{
              display: {
                xs: 'block',
                sm: 'none',
              },
            }}
          >
            <Typography variant="h7">{title}</Typography>
          </Stack>
        )}
        {children}
      </CardContent>
    </Card>
  );
};
